import React, { Component } from 'react';
import ForgotView from './ForgotPasswordView';
// import queryString from 'query-string';
import { url } from '../../../Server/url/GlobalUrl';



class ForgotComponent extends Component {
    state = {
        email: '',
        modal_show: false,
        authResponse:'',
        }

     hideCustomModal = () => {
        this.setState({ modal_show: false })
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })
    }

    handelData  = (data) =>{
        console.log('data',data)
        this.setState({email : data})
    }

    handelSummit = () =>{
        if (this.state.email !== ''){
            console.log('successs')
           let email = encodeURIComponent(this.state.email)
            fetch((url + "/forgot-email/?email=" + email), {
                method: 'GET'
            })
		    .then((response) => {

                return response.json()
		    })
		    .then((result) => {
		        if (result.length > 0){
                    console.log('successs')
                    this.showCustomModal()
                    var string = 'please check your email for resetting the password'
                    this.setState({authResponse:string})
		        }else {
		            this.showCustomModal()
                    var string = 'No active accounts found with this email'
                    this.setState({authResponse:string})
		        }
		    })
		    }

        else{
            this.showCustomModal()
            var string = 'Email is required'
            this.setState({authResponse:string})
            console.log('Email is required')
        }
    }
    render() {
        return (<ForgotView
            handelSummit = {this.handelSummit}
            handelData = {this.handelData}
            authResponse = {this.state.authResponse}
            modal_show = {this.state.modal_show}
            hideCustomModal = {this.hideCustomModal}
        />)
    }
}

export default ForgotComponent;